import React from "react";
import { StyledIconButton } from "../../elements/ElementsIndex";
import { StyledFab } from "./GridRowAction.style";

const GridRowAction = (props) => {
  return (
    <StyledIconButton
      loadingStatus={props.loadingStatus}
      //loadingColor="#354A55"
    >
      <StyledFab
        color={props.color ? props.color : "#354A55"}
        sx={{
          width: props.width ? props.width : 30,
          height: props.height ? props.height : 30,
          // display: "none",
        }}
        disabled={props.disabled ? props.disabled : false}
        onClick={props.handleSubmit}
      >
        {props.children}
      </StyledFab>
    </StyledIconButton>
  );
};

export default GridRowAction;
